import { createFileRoute } from "@tanstack/react-router";

import { BrandLockup, HeroSubtitle } from "@/components/marketing/BrandLockup";
import FaqSection from "@/components/marketing/FaqSection";
import HowItWorks from "@/components/marketing/HowItWorks";
import LyricVideoCustomization from "@/components/marketing/lyric-video/LyricVideoCustomization";
import LyricVideoDemo from "@/components/marketing/lyric-video/LyricVideoDemo";
import LyricVideoFormats from "@/components/marketing/lyric-video/LyricVideoFormats";
import { marketingHead } from "@/components/marketing/marketingHead";
import ProductHero from "@/components/marketing/ProductHero";
import RelatedProducts from "@/components/marketing/RelatedProducts";
import Footer from "@/components/nav/Footer";

const LEDE = "Automatic with every upload. Fully customizable.";

export const Route = createFileRoute("/lyric-video")({
  component: LyricVideoPage,
  head: () =>
    marketingHead({
      title: "AI Lyric Video Maker | Lutely",
      description: LEDE,
      path: "/lyric-video",
    }),
});

const FAQ = [
  {
    question: "Do I need to upload a separate lyric file?",
    answer:
      "No. Lutely automatically transcribes the lyrics from your track. You can review and edit them before creating your video.",
  },
  {
    question: "Can I edit the lyrics?",
    answer:
      "Yes. You can review and update your track’s lyrics before using them in your lyric video.",
  },
  {
    question: "Can I customize how the video looks?",
    answer:
      "Yes. You can adjust the text, background, and animation, then preview the video with your music before exporting.",
  },
  {
    question: "What sizes can I export?",
    answer:
      "Export options include landscape 16:9, vertical 9:16, square 1:1, classic 4:3, and portrait 3:4.",
  },
];

function LyricVideoPage() {
  return (
    <main className="flex flex-col bg-white">
      <ProductHero
        title={
          <>
            <HeroSubtitle>
              Turn your
              <br />
              songs into
            </HeroSubtitle>
            <br />
            <BrandLockup>lyric videos.</BrandLockup>
          </>
        }
        lede={LEDE}
        cta="Make a lyric video"
        secondaryLabel="Learn more ↓"
        stage={<LyricVideoDemo />}
        plainStage
      />
      <HowItWorks
        kicker={false}
        title="How it works"
        steps={[
          {
            title: "Upload a track",
            body: "Lutely automatically transcribes and timestamps your lyrics and creates your video.",
          },
          {
            title: "Review & customize",
            body: "Review and edit your lyrics, then customize the look and feel to make the video your own.",
          },
          {
            title: "Export & share",
            body: "Download your lyric video in the formats you need for YouTube, social media, and wherever your music goes.",
          },
        ]}
      />
      <LyricVideoCustomization />
      <LyricVideoFormats />
      <FaqSection items={FAQ} />
      <RelatedProducts current="lyricVideo" />
      <Footer />
    </main>
  );
}
